import { useState, useEffect } from 'react'

import { utils } from '../utils'
import { userService } from '../services'
import { useAuth } from '.'

const useProfile = () => {
  const userCurrent = useAuth()
  const [user, setUser] = useState<any>({})

  useEffect(() => {
    getUserCurrent()
  }, [])

  const getUserCurrent = async () => {
    const resp = await userService.getUserCurrent()
    setUser(resp.data)
  }

  const getUserAvatar = async (avatarDefaultImg: string) => {
    const userInfo = userCurrent.getInfo()
    const resp = await userService.getUserImages(userInfo.id)
    return (resp && resp.data && resp.data.file_profile ? utils.getImagenBase64(resp.data.file_profile) : avatarDefaultImg)
  }

  return {
    user,
    getUserCurrent,
    getUserAvatar
  }
}

export { useProfile }